const env = import.meta.env.DEV ? import.meta.env : window && window.env;

const APP_TITLE = env.VITE_APP_TITLE || 'My Viking Journey';
const MVJ_API = env.VITE_APP_MVJ_API || 'https://mvj-api.viking.com/v1';
const ENVIRONMENT_CODE = env.VITE_APP_ENVIRONMENT_CODE || 'dev';
const MVJ_DOMAIN = env.VITE_APP_MVJ_DOMAIN || 'https://csadmin.viking.com';
const VALID_USER_TYPES = new Set(['CSA', 'AIR']);
const ENABLE_UNLOCK = false;

const B2C_USER_TYPES = {
  CONSUMER: { label: 'Consumer', value: 'Consumer' },
  TRAVEL_ADVISOR: { label: 'TA (Travel Advisor)', value: 'TA' },
};

const FORMS = {
  EDIT_NAME: 'editname',
  LOGIN: 'login',
  SEARCH: 'search',
  SEARCH_BY_USER: 'searchByUser',
  SIGN_IN_AS: 'signInAs',
};

const EDIT_FORM_TYPE = {
  B2C_USER: 'b2c',
  MVJ_USER: 'mvj',
};

const EDIT_NAME_STEPS = {
  CONFIRM_EDIT: 'confirmEdit',
  CONFIRM_EMAIL: 'confirmEmail',
  EDIT: 'edit',
};

const MODALS = {
  EDIT_NAME: 'editName',
};

const LOADING = 'LOADING';

const USER_TYPES = {
  AIR: 'AIR',
  CSA: 'CSA',
};

const REDIRECT_PATHS = ['/login'];

const ROLES_BY_ENV = {
  CSA_NON_PROD: 'csadmin-users',
  CSA_PROD: 'csadmin-users-prod',
  PS_NON_PROD: 'csadmin-prod-support-users',
  PS_PROD: 'csadmin-prod-support-users-prod',
};

const CSADMIN_ROLE = ENVIRONMENT_CODE === 'prod' ? ROLES_BY_ENV.CSA_PROD : ROLES_BY_ENV.CSA_NON_PROD;
const PROD_SUPPORT_ROLE = ENVIRONMENT_CODE === 'prod' ? ROLES_BY_ENV.PS_PROD : ROLES_BY_ENV.PS_NON_PROD;

const ROLE_NAMES = {
  [ROLES_BY_ENV.CSA_NON_PROD]: 'MVJ Customer Service Admin (Non-Prod)',
  [ROLES_BY_ENV.CSA_PROD]: 'MVJ Customer Service Admin',
  [ROLES_BY_ENV.PS_NON_PROD]: 'Viking Product Support (Non-Prod)',
  [ROLES_BY_ENV.PS_PROD]: 'Viking Product Support',
};

const APP_PAGES = {
  INDEX: {
    pageTitle: 'CUSTOMER SERVICE',
    path: '/',
    roles: [CSADMIN_ROLE, PROD_SUPPORT_ROLE],
    title: 'Bookings',
  },
  USERS: {
    pageTitle: 'CUSTOMER SERVICE',
    path: '/users',
    roles: [PROD_SUPPORT_ROLE],
    title: 'User Management',
  },
  SIGN_OUT: {
    pageTitle: 'CUSTOMER SERVICE',
    path: '/sign-out',
    roles: [],
    title: 'Sign Out',
  },
};

export {
  APP_PAGES,
  APP_TITLE,
  B2C_USER_TYPES,
  CSADMIN_ROLE,
  EDIT_FORM_TYPE,
  EDIT_NAME_STEPS,
  ENABLE_UNLOCK,
  env,
  ENVIRONMENT_CODE,
  FORMS,
  LOADING,
  MODALS,
  MVJ_API,
  MVJ_DOMAIN,
  PROD_SUPPORT_ROLE,
  REDIRECT_PATHS,
  ROLE_NAMES,
  USER_TYPES,
  VALID_USER_TYPES,
};
